module.exports = __webpack_public_path__ + "static/media/grid-1.c68bfb3a.jpg";